import { getDateTimeFormatter } from '@fe/core';
import { GDFPirepRecord } from '../../../gdf/type';

export default function PirepTooltip({ record }: { record: GDFPirepRecord }) {
    const formatter = getDateTimeFormatter();
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'max-content auto', columnGap: '1rem' }}>
            <div>Turbulence intensity:</div>
            <div>{turbulenceSeverity[record.turbIntensity ?? 0] ?? '---'}</div>

            <div>Icing intensity:</div>
            <div>{icingSeverity[record.icingIntensity ?? 0] ?? '---'}</div>

            <div>ID:</div>
            <div>{record.id || '---'}</div>

            <div>Reported:</div>
            <div>{formatter.formatTime(record.time, 'hm')}</div>

            <div>Wind direction:</div>
            <div>{record.windDir ?? '---'}</div>

            <div>Wind speed:</div>
            <div>
                {record.wind ?? '---'}
                {record.wind !== null && ' kts'}
            </div>

            <div>Temperature:</div>
            <div>{record.temp ?? '---'}</div>

            <div>Report text:</div>
            <div>{record.text || '---'}</div>
        </div>
    );
}

const turbulenceSeverity: Partial<Record<number, string>> = {
    [1]: 'Smooth (Negative)',
    [2]: 'Smooth-Light',
    [3]: 'Light',
    [4]: 'Light-Moderate',
    [5]: 'Moderate',
    [6]: 'Moderate-Severe',
    [7]: 'Severe',
    [8]: 'Severe-Extreme',
    [9]: 'Extreme'
};

const icingSeverity: Partial<Record<number, string>> = {
    [1]: 'Negative',
    [2]: 'Trace',
    [3]: 'Trace/Light',
    [4]: 'Light',
    [5]: 'Light/Moderate',
    [6]: 'Moderate',
    [8]: 'Severe',
    [7]: 'Moderate/Severe'
};
